/**
 * Assistant chart palette, mirroring the portal dashboard theme.
 *
 * These are the dashboard's own hues (see `tailwind.config.js`): the blue
 * primary first, then the success, warning and error hues, then the lighter
 * tints. Charts rendered in the Assistant now match the dashboards instead of
 * the single hardcoded blue this file replaces.
 *
 * The backend sends explicit colours when it has already chosen them; these are
 * the fallback for the default render path.
 */
export const CHART_PALETTE = [
  "rgba(59,130,246,0.8)",
  "rgba(34,197,94,0.8)",
  "rgba(245,158,11,0.8)",
  "rgba(239,68,68,0.8)",
  "rgba(96,165,250,0.8)",
  "rgba(74,222,128,0.8)",
  "rgba(251,191,36,0.8)",
  "rgba(248,113,113,0.8)",
] as const;

export const CHART_BORDER_PALETTE = [
  "rgba(37,99,235,1)",
  "rgba(22,163,74,1)",
  "rgba(217,119,6,1)",
  "rgba(220,38,38,1)",
  "rgba(59,130,246,1)",
  "rgba(34,197,94,1)",
  "rgba(245,158,11,1)",
  "rgba(239,68,68,1)",
] as const;

/** `count` palette colours, one per measure, cycling when there are more series than colours. */
export const getMeasureColors = (count: number): string[] =>
  count <= 0
    ? []
    : Array.from({ length: count }, (_, index) => CHART_PALETTE[index % CHART_PALETTE.length]);

/** Border colours matching `getMeasureColors`. */
export const getBorderColors = (count: number): string[] =>
  count <= 0
    ? []
    : Array.from(
        { length: count },
        (_, index) => CHART_BORDER_PALETTE[index % CHART_BORDER_PALETTE.length],
      );

/** A ranked comparison reads far better as a bar chart than as a pie. */
export const isRankedComparison = (labelCount: number): boolean => labelCount > 5;
